function getParameterByName(name, href) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regexS = '[\\?&]' + name + '=([^&#]*)';
  var regex = new RegExp(regexS);
  var results = regex.exec(href);
  if (results == null) return '';
  else return decodeURIComponent(results[1].replace(/\+/g, ' '));
}

window.onGigyaServiceReady = function () {
  gigya = window.gigya;
  gigya.showScreen = function (screenSet, screenName, containerID) {
    gigya.accounts.showScreenSet({
      screenSet: screenSet,
      startScreen: screenName,
      containerID: containerID,
      customLang: {
        email_address_is_invalid: 'Email address is invalid.',
        password_does_not_meet_complexity_requirements:
          'Password must include 1 number and 1 letter, and be a minimum of 8 characters.',
        invalid_login_or_password: 'Invalid email address or password. Please try again.',
        email_already_exists:
          'There is already a Zoetis Petcare Pro account with this email address. Would you like to <a href="javascript:void(0)" onclick="window.location.reload(false);">sign in?</a>',
      },
      onBeforeSubmit: gigya.removeErrors,
    });
  };

  gigya.socialize.addEventHandlers({
    onLogin: function (response) {
      gigya.setNavigationForLoggedInUser(response);
    },
    onLogout: function () {},
  });

  if (getParameterByName('pwrt', window.location) != '') {
    gigya.showScreen('RegistrationLogin', 'gigya-reset-password-screen', 'gigya-content');
  }

  gigya.removeErrors = function () {
    $('.gigya-error-msg').html('');
  };

  gigya.setNavigationForLoggedInUser = async (response) => {
    var injector = angular.element(document.querySelector('[ng-app]')).injector();
    var Session = injector.get('Session');
    var $rootScope = injector.get('$rootScope');
    var ATLAS_API = injector.get('ATLAS_API');
    var AuthService = injector.get('AuthService');
    var UserService = injector.get('UserService');
    await $rootScope.clearData();

    var userData = {
      username: response.UIDSignature,
      timestamp: response.signatureTimestamp,
      password: response.UID,
      client_id: ATLAS_API.clientId,
      grant_type: 'password',
    };
    AuthService.login(userData).then(
      async (response) => {
        //save token to Session so it can be sent across all requests
        await Session.setTokens(response.access_token, response.refresh_token, response.expires_in);
        await UserService.checkAndGrabUserInfo();
      },
      function () {
        $('div.gigya-error-msg')
          .html('There was a problem with your login, please try again later')
          .addClass('gigya-error-msg-active');
        $('.gigya-error-display').show();
      },
    );
    $rootScope.$digest();
  };

  gigya.showScreen('RegistrationLogin', 'gigya-login-screen', 'login-form');

  if (getParameterByName('pwrt', window.location) != '') {
    gigya.showScreen('RegistrationLogin', 'gigya-reset-password-screen', 'login-form');
  }
};
